import React, {useContext, useEffect, useState} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import useValetStore from "./hooks/useValetStore";
import {
    PaymentElement, useElements,
    useStripe
} from "@stripe/react-stripe-js";
import Swal from "sweetalert2";
import {PaymentType} from "../../constants/PaymentType";
import {ValetSteps} from "./constants/ValetSteps";
import Price from "../../components/v2/Price";
import {useSelector} from "react-redux";
import {getBrandData} from "../branded/locationGroupSlice";
import {RouteType} from "./constants/RouteType";
import ConfigurationContext from "../../contexts/configurationContext";
import {Link} from "@mui/material";
import Alert, {ERROR} from "../../components/v2/Alert";
import {useTranslation} from "react-i18next";

export default function ValetPaymentStripe({
                                               searchParams = null
                                           }) {

    const stripe = useStripe();
    const elements = useElements();
    const [show, setShow] = React.useState(false);

    const brandData = useSelector(getBrandData);

    const applicationSettingsContext = useContext(ConfigurationContext);
    const [agree, setAgree] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const {
        callPost,
        valetIntent,
        userData,
        setStep,
        loading,
        setLoading,
    } = useValetStore();

    const {t} = useTranslation('common');

    useEffect(() => {
        if (searchParams.get('payment_intent') != null) {
            // On vérifie / valide le payment
            callPost('valet_only_verify_payment', {
                'stripe_payment_intent_id': searchParams.get('payment_intent'),
            }, (data) => {
                setLoading(loading - 1);
                setStep(ValetSteps.ORDER_DONE);
            }, (failResultData) => {
                Swal.fire({
                    text: failResultData.message,
                    icon: 'error',
                });
            });
        } else {
            setShow(true);
        }
    }, [searchParams]);

    const payClickedHandler = function (e) {
        e.preventDefault();

        if (!agree) {
            setErrorMessage(t("valet.payment_stripe.agree_terms"));
            return;
        }
        setErrorMessage(null);

        // Trigger form validation and wallet collection
        elements.submit().then((result) => {
            // console.log("submitResult", result);
            if (result.error) {
                return; // elements affiche de lui-même les erreurs
            }

            setLoading(loading + 1);    // On encapsule toute la démarche dans un loading

            // Etape 1 on créer l'intent
            callPost('valet_only_order_intent', {
                'valet_intent_id': valetIntent.id,
                'vehicle_id': userData.vehicle.vehicle.id,
                'date': userData.travel.date,
                'time': userData.travel.time,
                'retrieve_hour': userData.travel.routeType == RouteType.GOING_AND_COMING ? userData.travel.retrieveHour : null,
                'phone': userData.travel.phone,
                'comment': userData.travel.comment,
                'delivery_contact_name': userData.travel.deliveryContactName,
                'delivery_contact_phone': userData.travel.deliveryContactPhone,
                'payment_type_id': PaymentType.CREDIT_CARD,
                'location_group_id': brandData?.id
            }, (data) => {
                // On envoi le paiement à stripe
                let location = window.location;
                let callbackUrl = location.protocol + '//' + location.hostname + ':' + location.port + '/valet';
                stripe.confirmPayment({
                        elements,
                        clientSecret: data.client_secret,
                        confirmParams: {
                            return_url: callbackUrl,
                        }
                    }
                )
            }, (failResultData) => {
                Swal.fire({
                    text: failResultData.message,
                    icon: 'error',
                });
            });
        });
    }


    if (show) {
        return <div className="h-full flex flex-col p-4 gap-4">
            <StepperCar value={90}/>
            <div className="flex flex-nowrap justify-between items-center">
                <div className="text-white text-[28px] font-bold">{t("valet.payment_stripe.title")}</div>
                <Price value={valetIntent.price}/>
            </div>
            <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
                <legend className="text-sm">&nbsp;{t("valet.payment_stripe.detail")}&nbsp;</legend>
                <PaymentElement id="payment-element" options={{
                    layout: 'tabs',
                    paymentMethodOrder: ['card']
                }}/>
            </fieldset>

            <div className="flex gap-2 items-start">
                <input className="min-w-4 min-h-4 mt-1" id="agree" type="checkbox" checked={agree}
                       onChange={(e) => setAgree(e.currentTarget.checked)}/>
                <label htmlFor={"agree"}>{t("valet.payment_stripe.agree")} <Link
                    style=
                        {{
                            textDecoration: 'none',
                            color: '#fbc70f'
                        }}
                    // https://keepupcar.com/wp-content/uploads/2018/03/CGV-Keep-Up-Car-1.pdf
                    href={applicationSettingsContext == null ? '' : applicationSettingsContext.URL_CGV}
                    target="_blank"
                >
                    {t("valet.payment_stripe.agree2")}
                </Link> {t("valet.payment_stripe.agree3")}</label>
            </div>
            {errorMessage != null ?
                <Alert type={ERROR}
                       text={errorMessage}
                /> : null
            }
            <div className="grow">
            </div>
            <Button text={t("valet.payment_stripe.pay")} clickHandler={payClickedHandler}/>
            <Button outline text={t("valet.payment_stripe.back")}
                    clickHandler={(e) => setStep(ValetSteps.SUMMARY)}/>
        </div>
    } else {
        return null;
    }

}